import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import CMAlert from '../atoms/CMAlert';

const CMNotification = ( props ) => {

  const handleClose = (event, reason) => {
    if (reason === 'clickaway')
      return;
    
    props.setNotify({
      ...props.notify,
      isOpen: false
    })
  }

  return (
    <>
      <Snackbar
        open={props.notify.isOpen}
        onClose={handleClose}
        {...props}
      >
        <CMAlert 
          severity={props.notify.type}
          onClose={handleClose}
          sx={{ width: '100%' }}
        >
          {props.notify.message}
        </CMAlert>
      </Snackbar>
    </>
  )
}
export default CMNotification;